module.exports = __webpack_public_path__ + "img/ods-texto-cuadrado.3a173e21.png";